import React from "react";

const BookTitle = ({title}) => {
    return (
        <li className="font-bold text-2xl list-none p-4 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-white rounded-lg shadow-lg">{title}</li>
    )
}

export default BookTitle;